(function ($, njm) {
    'use strict';

    njm.views.agentSearch = Backbone.View.extend({

        events: {
            'click .custom-select .selected': 'dropdownClick',
            'click .custom-select .icon-arrow': 'dropdownClick',
            'keydown .custom-select .selected': 'dropdownKeydown',
            'keydown .custom-select .icon-arrow': 'dropdownKeydown',
            'click .custom-select ul a': 'dropdownSelectionClick',
            'keydown .custom-select ul a': 'dropdownSelectionKeydown',
            'keydown .custom-select ul input': 'dropdownSelectionKeydown',
            'click #lob-filter input[type="checkbox"]': 'lobFilterSelection',
            'keydown #pageInput': 'fnPagination',
        },

        initialize: function () {
            this.dropdown = false;
            this.focusableEls = $('.comp-agent-search .custom-select ul li a');
            this.firstFocusableEl = this.focusableEls[0];
            this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
            this.focusedEl = false;

            var $this = this;

            //Hide dropdown with click outside of it
            $(document).click(function (event) {
                if ($(event.target).closest('.comp-agent-search .custom-select').length < 1) {
                    $this.hideDropdown(event);
                }
            });

            $this.lobFilterSelection();
        },


        dropdownClick: function (event) {
            var target = $(event.target);

            if (target.parents('.custom-select').find('.selected').attr('aria-expanded') === 'false') {
                this.hideDropdown();
                this.showDropdown(event);
            } else {
                this.hideDropdown();
            }
        },

        dropdownKeydown: function (event) {
            var key = event.which;
            var target = $(event.target);

            if (key === 13 || key === 32) { //enter or space
                this.dropdownClick(event);
                event.preventDefault();
            }

            if (key === 27) { //escape
                this.hideDropdown(event);
                target.parents('.custom-select').find('.selected').focus();
            }

            if (key === 38) { //up arrow
                event.preventDefault();
                if (!this.dropdown) {
                    this.showDropdown(event);
                }
                this.focusPrevious();
            }

            if (key === 40) { //down arrow
                event.preventDefault();
                if (!this.dropdown) {
                    this.showDropdown(event);
                }
                this.focusNext();
            }

            if (key === 9) { //tab
                if (this.dropdown) {
                    if (event.shiftKey) {
                        event.preventDefault();
                        this.focusPrevious();
                    } else {
                        event.preventDefault();
                        this.focusNext();
                    }
                }
            }
        },

        dropdownSelectionClick: function (event) {
            var target = $(event.target);
            var dataValue = target.parent().attr('data-value');

            target.parents('.custom-select').find('.selected').text(target.text());
            target.parents('.custom-select').find('#distanceValue').attr('value', dataValue);
            this.hideDropdown(event);
            $('.comp-agent-search .selected').focus();
        },

        dropdownSelectionKeydown: function (event) {
            var key = event.which;
            var target = $(event.target);

            if (key === 13 || key === 32) { //enter or space
                $(event.target).trigger('click');
                event.preventDefault();
            }

            if (key === 27) { //escape
                this.hideDropdown(event);
                target.parents('.custom-select').find('.selected').focus();
            }

            if (key === 38) { //up arrow
                event.preventDefault();
                this.focusPrevious();
            }

            if (key === 40) { //down arrow
                event.preventDefault();
                this.focusNext();
            }

            if (key === 9) { //tab
                if (event.shiftKey) {
                    event.preventDefault();
                    this.focusPrevious();
                } else {
                    event.preventDefault();
                    this.focusNext();
                }
            }
        },

        hideDropdown: function (event) {

            if (event && ($(event.target) === $('#distance .custom-select .selected') || $(event.target) === $('#distance .custom-select i'))) {
                $('.comp-agent-search #lob-filter .custom-select').find('ul').slideUp();
                $('.comp-agent-search #lob-filter .custom-select').find('.icon-arrow').removeClass('open');
                $('.comp-agent-search #lob-filter .selected').attr('aria-expanded', 'false');
                this.dropdown = false;
                this.focusedEl = false;
            } else if (event && ($(event.target) === $('#lob-filter .custom-select .selected') || $(event.target) === $('#lob-filter .custom-select i'))) {
                $('.comp-agent-search #distance .custom-select').find('ul').slideUp();
                $('.comp-agent-search #distance .custom-select').find('.icon-arrow').removeClass('open');
                $('.comp-agent-search #distance .selected').attr('aria-expanded', 'false');
                this.dropdown = false;
                this.focusedEl = false;
            } else {
                $('.comp-agent-search .custom-select').find('ul').slideUp();
                $('.comp-agent-search .custom-select').find('.icon-arrow').removeClass('open');
                $('.comp-agent-search .selected').attr('aria-expanded', 'false');
                this.dropdown = false;
                this.focusedEl = false;
            }
        },

        showDropdown: function (event) {

            var target = $(event.target);

            target.parents('.custom-select').find('ul').slideDown();
            target.parents('.custom-select').find('.icon-arrow').addClass('open');
            target.parents('.custom-select').find('.selected').attr('aria-expanded', 'true');
            this.dropdown = true;

            this.focusableEls = target.parents('.custom-select').find('ul li a, ul li input:not([type=hidden])');
            this.firstFocusableEl = this.focusableEls[0];
            this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
        },

        lobFilterSelection: function () {
            var checked = $('#lob-filter input[type="checkbox"]:checked'),
                numChecked = checked.length,
                selectedEl = $('#lob-filter .selected'),
                selectedText, i;

            if (numChecked === 0) {
                selectedText = selectedEl.attr('data-default-text');
            } else if (numChecked === 1) {
                selectedText = checked.siblings('label').text();
            } else if (numChecked === 2) {
                selectedText = checked.eq(0).siblings('label').text() + " and " + checked.eq(1).siblings('label').text();
            } else if (numChecked > 2) {
                selectedText = '';
                for (i = 0; i < numChecked; i++) {
                    if (i < numChecked - 1) {
                        selectedText += checked.eq(i).siblings('label').text() + ', ';
                    } else {
                        selectedText += 'and ' + checked.eq(i).siblings('label').text();
                    }
                }
            }

            selectedEl.val(selectedText);
        },

        focusNext: function () {
            if (!this.focusedEl) {
                this.firstFocusableEl.focus();
                this.focusedEl = 1;
            } else if (this.focusedEl === this.focusableEls.length) {
                this.firstFocusableEl.focus();
                this.focusedEl = 1;
            } else {
                this.focusableEls[this.focusedEl].focus();
                this.focusedEl++;
            }
        },

        focusPrevious: function () {
            if (this.focusedEl === 1 || !this.focusedEl) {
                this.lastFocusableEl.focus();
                this.focusedEl = this.focusableEls.length;
            } else {
                this.focusedEl--;
                this.focusableEls[this.focusedEl - 1].focus();
            }
        },

        fnPagination: function (event) {
            if (event !== undefined) {
                if (event.keyCode === 13) {
                    var pageInput = $('#pageInput').val();
                    var totalPageCount = $("#TotalPageCount").val();
                    if (pageInput !== undefined && totalPageCount !== undefined) {
                        if (pageInput.length == 0 || parseInt(pageInput) < 1) {
                            pageInput = 1
                        }
                        else if (parseInt(totalPageCount) < parseInt(pageInput)) {
                            pageInput = totalPageCount
                        }
                        $('input[name=page]').val(pageInput).trigger('change');
                    }
                }
            }
        }

    })

})(jQuery, njm);
